import { render, staticRenderFns } from "./ObjectIcon.vue?vue&type=template&id=ac2d753c&"
import script from "./ObjectIcon.vue?vue&type=script&lang=js&"
export * from "./ObjectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports